var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignetColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 115 123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "m110.66 43.539-29.158 13.2a10.328 10.328 0 0 1-9.423-.465L59.307 48.9a10.328 10.328 0 0 1-5.114-7.929L51.041 9.075A8.262 8.262 0 0 1 59.279 0l11.226.022a4.077 4.077 0 0 1 4.04 4.557l-3.13 26.463a5.164 5.164 0 0 0 2.546 5.08l1.836 1.06a5.164 5.164 0 0 0 5.7-.355L102.64 20.82a4.078 4.078 0 0 1 5.978 1.188l5.762 9.822a8.263 8.263 0 0 1-3.72 11.708Zm-59.258 70.428 2.99-31.904a10.328 10.328 0 0 1 5.09-7.964l12.828-7.462a10.328 10.328 0 0 1 9.476-.47l29.271 13.34a8.263 8.263 0 0 1 3.687 11.721l-5.663 9.587a4.077 4.077 0 0 1-5.945 1.196l-21.147-15.74a5.164 5.164 0 0 0-5.655-.336l-1.83 1.05a5.164 5.164 0 0 0-2.556 5.09l3.129 26.29a4.078 4.078 0 0 1-4.022 4.559L59.683 123a8.264 8.264 0 0 1-8.281-9.033Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#104C6A",
    fillRule: "evenodd",
    d: "m18.485 27.092 27.242 19.43a7.647 7.647 0 0 1 3.206 6.25l-.057 17.609a7.646 7.646 0 0 1-3.222 6.211L18.367 95.95A8.262 8.262 0 0 1 6.42 93.321L.913 83.719a4.077 4.077 0 0 1 1.914-5.769l25.298-10.978a3.823 3.823 0 0 0 2.302-3.517l-.01-3.887a3.823 3.823 0 0 0-2.309-3.5L3.054 45.256a4.077 4.077 0 0 1-1.956-5.712l5.352-9.713a8.262 8.262 0 0 1 12.035-2.74Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 56.527,
    x2: 115.895,
    y1: 61.5,
    y2: 61.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AD3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04A8B6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignetColor);
export default __webpack_public_path__ + "static/media/signetColor.54c7e05e7872cb76e6962ea74fa55078.svg";
export { ForwardRef as ReactComponent };